import React, { Suspense } from 'react'
import {
  Anchor,
  Button,
  Div,
  Flex,
  Input,
  LoadingSpinner,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import { useDebounce, useState } from 'src/hooks'
import { SponsorFragment } from 'src/graphql'
import SponsorSearch from './SponsorSearch'

const FindMySponsor = (props: {
  onSelectedSponsor: (sponsorId?: string) => void
}) => {
  const { onSelectedSponsor } = props
  const [search, setSearch] = useState<string>('')
  const debouncedSearch = useDebounce(search, 500)
  const [selectedSponsor, setSelectedSponsor] = useState<SponsorFragment>()

  return (
    <Flex flexDirection={'column'} width={'100%'} height={'100%'}>
      <Text type="subtitle" weight="bold">
        Who showed you this product?
      </Text>
      <Spacer space="x2" />
      <Input
        type="text"
        onChange={setSearch}
        value={search}
        placeholder="Search for your friend..."
        isFullWidth={true}
      />
      <Spacer space="x2" />
      <Div width="100%" maxHeight="310px" overflow="auto">
        <Suspense
          fallback={
            <Flex
              justifyContent="center"
              alignItems="center"
              height="205px"
              overflow="hidden"
            >
              <LoadingSpinner size="large" />
            </Flex>
          }
        >
          <SponsorSearch
            search={debouncedSearch}
            selectedSponsor={selectedSponsor}
            setSelectedSponsor={setSelectedSponsor}
          />
        </Suspense>
      </Div>
      <Flex
        flexDirection={'column'}
        alignItems={'center'}
        outset={{ top: 'auto' }}
      >
        <Spacer space="x2" />
        <Div>
          <Button
            title={
              search.length === 0
                ? 'Search for a Sponsor'
                : selectedSponsor
                ? `Choose ${selectedSponsor.firstName}`
                : `Choose a Sponsor`
            }
            onClick={() => onSelectedSponsor(selectedSponsor?.id)}
            disabled={!selectedSponsor}
            fullWidth={true}
            hover={true}
          />
        </Div>
        <Spacer space="x2" />
        <Anchor
          size="small"
          color="primaryBody"
          isDecorated={true}
          onClick={() => onSelectedSponsor()}
        >
          I found this product on my own.
        </Anchor>
      </Flex>
    </Flex>
  )
}

export default FindMySponsor
